<script lang="ts">
  import { onMount } from 'svelte'
  import Autoplay from 'embla-carousel-autoplay'
  import { browser } from '$app/environment'
  import * as Carousel from '$lib/components/shadcn/carousel/index'
  import type { CarouselAPI } from '$lib/components/shadcn/carousel/context'
  import ButaneImage from '$lib/components/ButaneImage.svelte'

  let collateralScrollerContent = [
    {
      id: 0,
      image: 'Image-4.png',
      title: 'Create Synthetic Assets',
      description: 'Borrow tokenised derivative assets directly from the protocol.',
    },
    {
      id: 1,
      image: 'Image-3.png',
      title: 'Synthetic Staking',
      description: 'Earn yield on your synthetics by staking them in the protocol.',
    },
    {
      id: 2,
      image: 'Image-5.png',
      title: 'Decentralised Governance',
      description: 'Vote with your BTN to shape the future of Butane.',
    },
    {
      id: 3,
      image: 'Image-6.png',
      title: 'Multi-Collateral',
      description: 'Utilise a variety of your Cardano native tokens (CNTs) as collateral for borrowing synthetics.',
    },
    {
      id: 4,
      image: 'Image-8.png',
      title: 'Action Composability',
      description: 'Execute complex strategies which perform multiple actions in a single transaction.',
    },
  ]

  let api: CarouselAPI
  let current = 0
  let count = 0
  const reducedMotionQuery = browser ? window.matchMedia('(prefers-reduced-motion: reduce)') : null
  let reduceMotion = reducedMotionQuery?.matches ?? false
  const autoplay = Autoplay({ delay: 8000, playOnInit: !reduceMotion })

  onMount(() => {
    const syncPreference = () => {
      const nextPreference = reducedMotionQuery?.matches ?? false
      if (nextPreference === reduceMotion) return
      reduceMotion = nextPreference
      if (reduceMotion) autoplay.stop()
      else autoplay.play()
    }
    syncPreference()
    reducedMotionQuery?.addEventListener('change', syncPreference)
    return () => reducedMotionQuery?.removeEventListener('change', syncPreference)
  })

  $: if (api) {
    count = api.scrollSnapList().length
    current = api.selectedScrollSnap()

    api.on('select', () => {
      current = api.selectedScrollSnap()
    })
  }
</script>

<div>
  <Carousel.Root bind:api opts={{ loop: true, align: 'center' }} plugins={[autoplay]}>
    <Carousel.Content>
      {#each collateralScrollerContent as { id, image }, index}
        <Carousel.Item class="basis-1/2 lg:basis-1/3">
          <div
            class="relative z-[2] mx-auto mb-6 flex flex-col items-center rounded-2xl border-2 border-[#272D37] bg-black p-8 py-10 lg-desktop:h-[450px] lg-desktop:w-[450px]"
          >
            <ButaneImage width={304} height={304} src={image} alt="collateral icon" loading="eager" />
            <div
              class="absolute -bottom-5 left-1/2 z-[1] flex -translate-x-1/2 transform items-center text-nowrap rounded-full border-2 border-[#272D37] bg-[#0A0A0C] p-2 px-3 text-xs md:text-sm sm-desktop:px-8"
            >
              {`0${id + 1} / 0${collateralScrollerContent.length}`}
            </div>
          </div>
        </Carousel.Item>
      {/each}
    </Carousel.Content>
    <div class="relative mx-auto mt-8 flex w-36 lg:w-48">
      <Carousel.Previous />
      <Carousel.Next />
    </div>
  </Carousel.Root>

  <div
    class="mt-[15vw] h-[180px] space-y-3 text-center transition-all duration-300 lg:mt-[5vw] lg:h-[100px]"
    aria-live={reduceMotion ? 'polite' : 'off'}
    aria-atomic="true"
  >
    <p
      class="mx-auto w-[80%] font-cirka text-[8vw] font-medium leading-[95%] lg-tablet:w-[550px] lg-tablet:text-[76px] lg-tablet:leading-[65px]"
    >
      {collateralScrollerContent[current].title}
    </p>
    <p class="mx-auto w-[320px] font-graphik">{collateralScrollerContent[current].description}</p>
  </div>
</div>
